import { useVeriModel, UseVeriModelOptions } from "../../useVeriModel";
import { WorkflowModel } from "../../../models";
import { apiWorkflowModel } from "./apiWorkflowModel";

export function useWorkflowModel(opts?: UseVeriModelOptions<WorkflowModel>) {
  return useVeriModel(apiWorkflowModel, opts);
}
